export const checksums = {
  "locales": "v3.5.0--ALf6FVeKIK8xM2kuiZQyYAThNigpzq4pB475U32iTLA",
  "recipes": "v3.5.0--RtwaFsU-R5bv23KK9yX1k-42bvyrScJZ4blmBs8qSVU",
  "docs": "v3.5.0--17yLbO586Y9Af-5Pt5KC4u1Qii5zp865CyHylpcEweE",
  "voixuserguide": "v3.5.0--MIjZgHxDKnICqrMswGbtYwAYDIREmByZXpTAMTNYOyc"
}
export const checksumsStructure = {
  "locales": "MUD7PhNehZwnHfv4lK6CYcX_mXIUci-hAlafExf135k",
  "recipes": "VjS2WINwFdN-H11kp7H1EIX5ggk3PHzSIfxmNz6JnFY",
  "docs": "RQ8AoU9-lZjh12QOotexakTI8fjr8W5wIq4rljMcmFw",
  "voixuserguide": "MPDD2LdZ0t_gRfxqnhFXPSwk1GSPXM4MIpARl0W-xfc"
}

export const tables = {
  "locales": "_content_locales",
  "recipes": "_content_recipes",
  "docs": "_content_docs",
  "voixuserguide": "_content_voixuserguide",
  "info": "_content_info"
}

export default {
  "locales": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "meta": "json",
      "stem": "string"
    }
  },
  "recipes": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "layout": "string",
      "meta": "json",
      "name": "string",
      "navigation": "json",
      "path": "string",
      "recipe": "json",
      "seo": "json",
      "stem": "string"
    }
  },
  "docs": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "order": "number",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "view": "string"
    }
  },
  "voixuserguide": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "order": "number",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "view": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}